// This file is included in the main bundle, so keep things to the minimum.
// Advanced showtimes interactions go in store/bolt/showtimes.js (loaded once the showtimes section is shown)

import Store from 'store/store';
import { openSidePanel, closeSidePanel } from 'store/bolt/sidePanelLoader';
import { commaSeparatedList } from 'utils/utils';
import { getBaseFilters } from 'utils/bolt/showtimesLoader';
import formatDateTime from 'utils/formatDateTime';
import parseQueryString from 'utils/parseQueryString';
import { geoFromIP, geoSearchOne } from 'utils/bolt/geo';

let initialDate = formatDateTime(new Date(), 'yyyy-MM-dd');

Store.on('SHOWTIMES_SHOW', (animate, queryString, pageId) => {
	let store = Store.get();
	let returnTo = store.activePage;
	let activePageComponent = store.appData?.pages?.[store.activePage]?.component;
	
	if (activePageComponent === 'filmPage' || activePageComponent === 'hub') {
		store.showtimes.set({ returnToPage: returnTo });
	}

	if (!pageId) {
		const pages = Store.get().appData?.pages || {};
		const aShowtimesPage = Object.values(pages).find(page => page.type === 'showtimes');
		pageId = aShowtimesPage?.id;
	}

	openSidePanel(animate, 'showtimes', false, queryString, pageId);
	// Should we somehow reset all filters here? Otherwise could get wrong when multiple showtimes pages
	//  (or check if ID changed compared to last viewed showtimes page)
	if (queryString) {
		refreshQueryString(queryString);
	}
});

Store.on('SHOWTIMES_SEARCH_OVERLAY_SHOW', () => {
	Store.emit('ENABLE_SCROLLING_LOCK');
	Store.get().header.set({ showtimesSearchOverlay: true });
});

Store.on('SHOWTIMES_SEARCH_OVERLAY_HIDE', () => {
	Store.emit('DISABLE_SCROLLING_LOCK');
	Store.get().header.set({ showtimesSearchOverlay: false });
});

Store.on('SHOWTIMES_HIDE', (animate, updateActivePage = true) => closeSidePanel(animate, updateActivePage, 'showtimes'));

Store.on('CLOSE_ALL_OVERLAYS', (options = {}) => {
	Store.emit('SHOWTIMES_HIDE', options.animate, false);
});

Store.on('LANDING', async () => {
	let store = Store.get();

	let activePageType = store.appData?.pages?.[store.activePage]?.type;
	const pageNeedsApi = activePageType === 'showtimes' || activePageType === 'filmPage' || activePageType === 'homeEnt';
	const disableGeo = pageNeedsApi && store.limitExceeded;

	if (!disableGeo) {
		Store.emit('SET_LANDING_LOCATION');
	}

	// Set current date to today
	let showtimesPage = Object.values(store.appData?.pages || {}).find(page => page.type === 'filmPage' || page.type === 'showtimes');
	if (showtimesPage?.type === 'filmPage') {
		showtimesPage = Object.values(showtimesPage?.data || {})?.find(section => section.type === 'showtimes') || {};
	}

	if (!showtimesPage?.data?.useV2) {
		let filters = store?.showtimes?.filters;
		if (filters?.selected) {
			filters.selected.set('date', [initialDate]);
		}
	}
});

Store.on('SET_LANDING_LOCATION', async () => {
	let landingGeo = geoFromIP;
	let query = parseQueryString();

	const { lat, lon, location, country } = query;

	if (+lat && +lon) {
		let usedCountry = country;
		if (!country) {
			usedCountry = __REGION__.replace(/^([a-z]{2})_.+$/i, '$1');
		}
		landingGeo = { lat: +lat, lon: +lon, city: location.replace(/\+/g, ' '), country: usedCountry.replace(/\+/g, ' ') };
	} else if (location && typeof location === 'string') {
		// geo needs to be set for geoSearch to work (here.com can only search in the current country -_-)
		// For now we akways use the result of geoFromUIp directly from geoSearch rather than the current location
		// let fromIP = await geoFromIP();
		// Store.get().client.geo.set({ lat: fromIP.lat, lon: fromIP.lon, city: fromIP.city }).now();
		landingGeo = () => geoSearchOne({ search: location });
	}

	Store.emit('SET_USER_LOCATION', landingGeo, 'landing');
});

async function refreshQueryString(qs) {
	let newFilters = await getBaseFilters(qs);
	Store.get()?.showtimes?.filters?.selected?.set(newFilters);
	if (newFilters?.date) {
		Store.get()?.showtimes?.filters?.set('userSelectedDate', true);
	}
	const parsed = parseQueryString(qs);
	if (parsed.ticketing) {
		Store.get()?.showtimes?.set('customDataProvider', commaSeparatedList(parsed.ticketing));
	}
	if (newFilters && Object.keys(newFilters).length) {
		Store.emit('FILTER_UPDATED');
	}
	if (parsed.formatmatch) {
		const formatMatches = parsed.formatmatch.split(',').filter(e => e.trim()).filter(x => x);
		if (formatMatches.length) {
			Store.get().showtimes.set({ queryFormatMatches: formatMatches });
		}
	}
}

Store.on('LANDING_QUERY', async () => {
	await refreshQueryString();
});
